import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { SmoothScroll } from "@/components/site/motion";
import Navbar from "@/components/site/Navbar";
import Footer from "@/components/site/Footer";
import StickyButtons from "@/components/site/StickyButtons";

export default function PageLayout({ children, testid }) {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <SmoothScroll>
      <div data-testid={testid} className="min-h-screen flex flex-col">
        <Navbar />
        <main className="flex-1">{children}</main>
        <Footer />
        <StickyButtons />
      </div>
    </SmoothScroll>
  );
}
